import type Transacao from "model/suprimentos/Transacao";

export default class TransacaoNotaFiscal {
    idSituacaoTributariaPadrao?: number | null;
    tributaIcms?: boolean | null;
    tributaIpi?: boolean | null;
    tributaPis?: boolean | null;
    tributaCofins?: boolean | null;
    incluiFreteBaseIcms?: boolean | null;
    incluiSeguroBaseIcms?: boolean | null;
    incluiOutrasDespesasBaseIcms?: boolean | null;
    incluiIpiBaseIcms?: boolean | null;
    incluiFreteBaseIpi?: boolean | null;
    incluiSeguroBaseIpi?: boolean | null;
    incluiOutrasDespesasBaseIpi?: boolean | null;
    incluiFreteBasePis?: boolean | null;
    incluiSeguroBasePis?: boolean | null;
    incluiOutrasDespesasBasePis?: boolean | null;
    incluiIpiBasePis?: boolean | null;
    incluiFreteBaseCofins?: boolean | null;
    incluiSeguroBaseCofins?: boolean | null;
    incluiOutrasDespesasBaseCofins?: boolean | null;
    incluiIpiBaseCofins?: boolean | null;
    excluiIcmsBasePis?: boolean | null;
    excluiIcmsBaseCofins?: boolean | null;

    id: number | null;
    finalidadeNfe: string;
    destinoOperacao: string;
    tipoOperacao: string;
    movimentaEstoque: boolean;
    ativa: boolean;
    codigoInterno: string;
    descricao: string;
    naturezaOperacao: string;
    transacaoEstoque: Transacao | null;
    cfopPadrao: string | null;
    cstIcmsPadrao: string | null;
    csosnPadrao: string | null;
    cstIpiPadrao: string | null;
    codigoEnquadramentoIpiPadrao: string | null;
    cstPisPadrao: string | null;
    cstCofinsPadrao: string | null;
    cstIbsCbsPadrao: string | null;
    classificacaoTributariaPadrao: string | null;
    aliquotaIcmsPadrao: number | null;
    aliquotaPisPadrao: number | null;
    aliquotaCofinsPadrao: number | null;
    aliquotaIcmsUfDestinoPadrao: number | null;
    aliquotaFcpUfDestinoPadrao: number | null;

    constructor(
        id: number | null = null,
        finalidadeNfe = 'NORMAL',
        destinoOperacao = 'INTERNA',
        tipoOperacao = 'SAIDA',
        movimentaEstoque = false,
        ativa = true,
        codigoInterno = '',
        descricao = '',
        naturezaOperacao = '',
        transacaoEstoque: Transacao | null = null,
        cfopPadrao: string | null = null,
        cstIcmsPadrao: string | null = null,
        csosnPadrao: string | null = null,
        cstPisPadrao: string | null = null,
        cstCofinsPadrao: string | null = null,
        cstIbsCbsPadrao: string | null = null,
        classificacaoTributariaPadrao: string | null = null,
        aliquotaIcmsPadrao: number | null = null,
        aliquotaPisPadrao: number | null = null,
        aliquotaCofinsPadrao: number | null = null,
        aliquotaIcmsUfDestinoPadrao: number | null = null,
        aliquotaFcpUfDestinoPadrao: number | null = null,
        cstIpiPadrao: string | null = null,
        codigoEnquadramentoIpiPadrao: string | null = null
    ) {
        this.id = id;
        this.finalidadeNfe = finalidadeNfe;
        this.destinoOperacao = destinoOperacao;
        this.tipoOperacao = tipoOperacao;
        this.movimentaEstoque = movimentaEstoque;
        this.ativa = ativa;
        this.codigoInterno = codigoInterno;
        this.descricao = descricao;
        this.naturezaOperacao = naturezaOperacao;
        this.transacaoEstoque = transacaoEstoque;
        this.cfopPadrao = cfopPadrao;
        this.cstIcmsPadrao = cstIcmsPadrao;
        this.csosnPadrao = csosnPadrao;
        this.cstIpiPadrao = cstIpiPadrao;
        this.codigoEnquadramentoIpiPadrao = codigoEnquadramentoIpiPadrao;
        this.cstPisPadrao = cstPisPadrao;
        this.cstCofinsPadrao = cstCofinsPadrao;
        this.cstIbsCbsPadrao = cstIbsCbsPadrao;
        this.classificacaoTributariaPadrao = classificacaoTributariaPadrao;
        this.aliquotaIcmsPadrao = aliquotaIcmsPadrao;
        this.aliquotaPisPadrao = aliquotaPisPadrao;
        this.aliquotaCofinsPadrao = aliquotaCofinsPadrao;
        this.aliquotaIcmsUfDestinoPadrao = aliquotaIcmsUfDestinoPadrao;
        this.aliquotaFcpUfDestinoPadrao = aliquotaFcpUfDestinoPadrao;
    }
}
